<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header pointer" (click)="expandOrCollapse()" [class.pointer]="!editMode">
        <panel-chevron [showBody]="showBody"></panel-chevron>
        @if (assessor) {
            <h3>Jurisdiction Specialists</h3>
        }
        @if (!assessor) {
            <h3>State Protocols</h3>
        }
        <div class="float-end header-button-container" (click)="$event.stopPropagation()">
            @if (!editMode && showBody && hasEditPermission) {
                <button class="ace-btn btn-text has-icon btn-primary"
                        (click)="goToEditMode()">
                    <i class="fa fa-pencil"></i>
                </button>
            }
            @if (editMode && showBody) {
                <div>
                    <button class="ace-btn btn-text has-icon btn-primary" [disabled]="exceptionToEdit || !hasEditPermission" (click)="save()">
                        <i class="fa fa-save"></i>
                    </button>
                    <button class="ace-btn btn-text has-icon btn-primary btn-danger" (click)="cancel()">
                        <i class="fa fa-close"></i>
                    </button>
                </div>
            }
        </div>
    </div>
    @if (showBody) {
        <div class="card-body">
            <ws-ace-loader [show]="serverAction" [size]="4" [hasOverlay]="true"></ws-ace-loader>
            <table class="table table-condensed">
                <tbody>
                    @for (row of jurisdictionSpecialists; track row) {
                        <tr>
                            <td class="text-end">
                                <strong>{{ row.propertyTypeName }}</strong>
                            </td>
                            <td>
                                @if (!editMode) {
                                    <div
                                        [style.color]="row.jurisdictionSpecialist.isException ? 'red' : 'initial'">
                                        {{ getJSDisplay(row) }}
                                    </div>
                                }
                                @if (editMode) {
                                    <div style="display: flex;">
                                        <div style="width: 400px;">
                                            <user-team-picker [restrictToRyanInstance]="true"
                                                              [disabled]="row.isNoneAssigned || row.disablePicker"
                                                              [userId]="row.jurisdictionSpecialist.userID"
                                                              [teamId]="row.jurisdictionSpecialist.teamID"
                                                              [user]="row.userTeamModel"
                                                              [parentUsers]="parentUsers"
                                                              (userChange)="jsUserChanged($event, row)">
                                            </user-team-picker>
                                        </div>
                                        @if (row.showNoneAssigned) {
                                            <div class="checkbox" style="margin: 5px 0 0 20px;">
                                                <label>
                                                    <input type="checkbox"
                                                           [(ngModel)]="row.isNoneAssigned"
                                                           (ngModelChange)="noneAssignedChanged(row)"
                                                           [disabled]="row.disablePicker"> None Assigned
                                                </label>
                                            </div>
                                        }
                                    </div>
                                }
                                @if (row.siteClassExceptions.length) {
                                    <div style="margin-top: 8px">
                                        <div style="font-style: italic; text-decoration: underline;">Exceptions
                                            (Specific Site Class Specialists):
                                        </div>
                                        <table class="exceptions-table">
                                            @for (exception of row.undeletedExceptions; track exception) {
                                                <tr>
                                                    <td>{{ exception.siteClassName }}</td>
                                                    <td>
                                                        @if (!isExceptionInEditMode(exception)) {
                                                            <span>{{ getAssigneeDisplaySafe(exception) }}</span>
                                                        }
                                                        @if (isExceptionInEditMode(exception)) {
                                                            <user-team-picker
                                                                [restrictToRyanInstance]="true"
                                                                [userId]="exceptionToEdit.userID"
                                                                [teamId]="exceptionToEdit.teamID"
                                                                [parentUsers]="parentUsers"
                                                                (userChange)="exceptionUserChanged($event, exception)"
                                                                [required]="true">
                                                            </user-team-picker>
                                                        }
                                                    </td>
                                                    @if (editMode) {
                                                        <td>
                                                            @if (isExceptionInEditMode(exception)) {
                                                                <button class="ace-btn has-icon btn-primary btn-danger"
                                                                        style="margin: 0;"
                                                                        (click)="cancelUserChange(exception, row)">
                                                                    <i class="fa fa-close"></i>
                                                                </button>
                                                            }
                                                            <span [class.invisible]="exceptionToEdit">
                                                                <button class="ace-btn has-icon btn-primary"
                                                                        style="margin: 0;"
                                                                        (click)="editException(exception)">
                                                                    <i class="fa fa-pencil"></i>
                                                                </button>
                                                                <button class="ace-btn has-icon btn-primary btn-danger"
                                                                        style="margin: 0;"
                                                                        (click)="deleteException(exception, row)">
                                                                    <i class="fa fa-trash"></i>
                                                                </button>
                                                            </span>
                                                        </td>
                                                    }
                                                </tr>
                                            }
                                        </table>
                                    </div>
                                }
                                @if (editMode && assessor) {
                                    <div style="margin: 15px 0; width: 400px">
                                        <ws-select placeholder="Add Site Class"
                                                   [(ngModel)]="row.chosenSiteClass"
                                                   (selectedOptionChanged)="addSiteClass(row)"
                                                   [options]="row.availableSiteClasses"
                                                   [disabled]="!!exceptionToEdit || row.disablePicker"
                                                   labelProperty="name"
                                                   [returnEntireOption]="true">
                                        </ws-select>
                                    </div>
                                }
                            </td>
                            <td>
                                @if (!editMode && row.propertyTypeXStateHasChildExceptions) {
                                    <button
                                        class="ace-btn btn-primary btn-sm"
                                        (click)="showExceptionsModal(row)">
                                        Assessor Exceptions
                                    </button>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</div>
